var render = function render(){var _vm=this,_c=_vm._self._c;return (this.singleSchool)?_c('div',{staticStyle:{"width":"100%"}},[_c('span',{staticClass:"d-sr-only",attrs:{"role":"alert","aria-label":this.schools[0].schoolName}}),_c('DataSwitcher',_vm._g(_vm._b({},'DataSwitcher',_vm.attrs,false),_vm.$listeners))],1):_c('DataSwitcher',_vm._g(_vm._b({},'DataSwitcher',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }